module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "aboutUs"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('footerBottomer', {
    staticStyle: {
      "margin-top": "130px"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kt-banner"
  }, [_c('label', {
    staticClass: "love"
  }, [_vm._v("为爱设计")]), _c('br'), _vm._v(" "), _c('label', {
    staticClass: "loveUs"
  }, [_vm._v("Design for love")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "aboutUsContent"
  }, [_c('div', {
    staticClass: "left classImg"
  }, [_c('img', {
    attrs: {
      "src": require("../../site/companyProfile.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "right classContent"
  }, [_c('p', {
    staticClass: "titleTxt"
  }, [_vm._v("爱宝惟简介")]), _vm._v(" "), _c('p', {
    staticClass: "textTxt"
  }, [_vm._v("深圳市爱宝惟生物科技有限公司成立于2013年7月，是2014-2018年国内互联网医疗行业“百糖大战”中为数不多的竞争存活者，也是国内较早开展糖尿病远程数字干预的专业服务机构。团队目前拥有“糖糖圈”及“糖妈妈”两条细分专业产品线、一个线下糖尿病专科门诊、以及30余人的全职糖尿病医护人员。平台合作三甲医院136家，入驻专科医生1096人、日均医护消息互动次数54398次，培育同伴互助组长（peer support leader）87人。")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "aboutUsContent"
  }, [_c('div', {
    staticClass: "right classImg"
  }, [_c('img', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "src": require("../../site/ttqMobile.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "left classContent"
  }, [_c('p', {
    staticClass: "titleTxt"
  }, [_vm._v("糖糖圈")]), _vm._v(" "), _c('p', {
    staticClass: "textTxt"
  }, [_vm._v("糖糖圈APP在2015年10月上线，2017年获得世界糖尿病基金会（WDF）资助。目前登记注册1型糖尿病患者人数42769人，日均患者血糖互助分享贴子500余条，已成为1型糖尿病医患交流平台。2014-2018年参与中国1型糖尿病登记管理项目，是中华医学会糖尿病分会中国1型糖尿病教育管理项目的合作伙伴，是中国医师协会中国1型糖尿病纵向队列建立项目科研、监察、随访管理服务平台。")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "aboutUsContent"
  }, [_c('div', {
    staticClass: "left classImg"
  }, [_c('img', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "src": require("../../site/tmmMobile.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "right classContent"
  }, [_c('p', {
    staticClass: "titleTxt"
  }, [_vm._v("糖妈妈")]), _vm._v(" "), _c('p', {
    staticClass: "textTxt"
  }, [_vm._v("糖妈妈APP在2021年9月份上线，是安徽省妊娠合并糖尿病专病联盟58家妇产科医院的院外随访管理服务平台，项目旨在帮助妇产科建立院外妊娠糖尿病随访管理队列，为妇幼血糖健康提供全生命周期的健康管理方案。项目已经入驻中国科学技术大学附属第一医院以及安徽省妇幼保健院。")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "aboutUsContent"
  }, [_c('div', {
    staticClass: "right classImg"
  }, [_c('img', {
    attrs: {
      "src": require("../../site/honor.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "left classContent history"
  }, [_c('p', {
    staticClass: "titleTxt"
  }, [_vm._v("历程与荣誉")]), _vm._v(" "), _c('p', {
    staticClass: "textTxt"
  }, [_vm._v("2018年获得天使轮融资估值4000万人民币;")]), _vm._v(" "), _c('p', {
    staticClass: "textTxt"
  }, [_vm._v("2018年获得民政部中国慈展会社会企业“中国好企业认证”;")]), _vm._v(" "), _c('p', {
    staticClass: "textTxt"
  }, [_vm._v("2019年社会创新家医疗社会创新TOP10;")]), _vm._v(" "), _c('p', {
    staticClass: "textTxt"
  }, [_vm._v("2019年获得美国Global perspectives on diabetes 杂志《Diabetes Voice》专题报道;")]), _vm._v(" "), _c('p', {
    staticClass: "textTxt"
  }, [_vm._v("2020年获得国家高新技术企业认证")]), _vm._v(" "), _c('p', {
    staticClass: "textTxt",
    staticStyle: {
      "margin-top": "20px",
      "line-height": "30px"
    }
  }, [_vm._v("2020年通过ISO/IEC 27701隐私信息管理体系（PIMS）及SO/IEC 27001信息安全管理体系（ISMS）认证;")]), _vm._v(" "), _c('p', {
    staticClass: "textTxt",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("2020年参与建立CDC中国1型糖尿病智能化管理与大数据中心;")]), _vm._v(" "), _c('p', {
    staticClass: "textTxt"
  }, [_vm._v("2020年荣获中国社会企业与影响力论坛“向光奖”;")]), _vm._v(" "), _c('p', {
    staticClass: "textTxt"
  }, [_vm._v("2020年参与创作并出版《我的血糖怪兽》系列科普绘本，获安徽省科普二等奖;")]), _vm._v(" "), _c('p', {
    staticClass: "textTxt"
  }, [_vm._v("2021年获得Pre-A轮融资估值3亿人民币;")]), _vm._v(" "), _c('p', {
    staticClass: "textTxt"
  }, [_vm._v("2021年获得亚洲银行家WEALTH&SOCIETY《2021财富与社会商业成就奖》;")]), _vm._v(" "), _c('p', {
    staticClass: "textTxt"
  }, [_vm._v("2021年参与成立“萱草1型糖尿病公益基金”;")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "aboutUsContent"
  }, [_c('div', {
    staticClass: "left classImg"
  }, [_c('img', {
    attrs: {
      "src": require("../../site/academicResearch.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "right classContent history"
  }, [_c('p', {
    staticClass: "titleTxt"
  }, [_vm._v("学术研究")]), _vm._v(" "), _c('p', {
    staticClass: "textTxt",
    staticStyle: {
      "margin-top": "20px",
      "line-height": "30px"
    }
  }, [_vm._v("1.《The Design and Preliminary Evaluation of a Mobile Health Application TangTangQuan in Management of Type 1 Diabetes in China》,2017,ADA;")]), _vm._v(" "), _c('p', {
    staticClass: "textTxt",
    staticStyle: {
      "margin-top": "20px",
      "line-height": "30px"
    }
  }, [_vm._v("2.《基于移动APP的互助式同伴支持对1型糖尿病血糖管理的效果评价》（国家重点研发计划2017YFC1309603）,2020,中华内科")]), _vm._v(" "), _c('p', {
    staticClass: "textTxt",
    staticStyle: {
      "margin-top": "20px",
      "line-height": "30px"
    }
  }, [_vm._v("3.《DIY人工胰腺能够为1型糖尿病患者带来更好的血糖控制和更高的生活质量》（电子壁报-485），2020，ATTD;")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "aboutUsContent"
  }, [_c('div', {
    staticClass: "right classImg"
  }, [_c('img', {
    attrs: {
      "src": require("../../site/newIcon.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "left classContent history"
  }, [_c('p', {
    staticClass: "titleTxt"
  }, [_vm._v("最新动态")]), _vm._v(" "), _c('p', {
    staticClass: "textTxt"
  }, [_c('a', {
    staticStyle: {
      "color": "#00b9cd",
      "text-decoration": "underline"
    },
    attrs: {
      "target": "_blank",
      "href": "https://www.ttq.so/html/news/detail-14093.html"
    }
  }, [_vm._v("\n          我司获得2023年度广东省科学技术奖公示\n        ")])]), _vm._v(" "), _c('p', {
    staticClass: "textTxt"
  }, [_c('a', {
    staticStyle: {
      "color": "#00b9cd",
      "text-decoration": "underline"
    },
    attrs: {
      "target": "_blank",
      "href": "https://www.ttq.so/html/news/detail-13848.html"
    }
  }, [_vm._v("\n          我司作为参与单位拟申报2022年中华医学会科技奖候选项目公示\n        ")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4a0cf9d6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/aboutUs.vue
// module id = 186
// module chunks = 1